module.exports = __webpack_public_path__ + "static/img/Partners5.106f69c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Partners5.png
// module id = FVQh
// module chunks = 10